import React, { useEffect, useState } from "react"
import { List, ListSubheader, Grid,Typography } from '@mui/material';
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { Chip } from "@mui/material";
import { cgcUploadTypes, namespace } from "../../../../../helper/namespace";
import { sweetStatusAlert } from "../../../../../components/common/SweetAlert";
import config from "../../../../../helper/config";

const CGCDocSubmission = ({ handleUploadFiles }) => {

    const [selectedFiles, setSelectedFiles] = useState({
        selectedFilePhoto: [],
        selectedFileSignature: [],
        selectedFileNIC: [],
        selectedFileAL: [],
        selectedFileOL: [],
        selectedFileWork: [],
        selectedFileOther: [],
    })

    const nameCheckForFileUpload = (file, typeName) => {
        const isHaveSameName = selectedFiles[typeName].some(file_ => file[0].name === file_[0].name)
        if (isHaveSameName) {
            sweetStatusAlert(namespace.FAILED, `File names are similar`, "error")
            return true
        }
        return false
    }

    const sizeCheckForFileUpload = (file) => {
        if (file[0].size > config.fileUploadConfigs.maxFileSize) {
            sweetStatusAlert(namespace.FAILED, `File cannot be uploaded. Check the size of the file ${file[0].name}!`, "error")
            return true
        }
        return false
    }

    const typeCheckForPhotoFileUpload = (file, type_id) => {
        console.log('type_id :', type_id)
        console.log('file :', file)
        if (type_id === cgcUploadTypes.CGC_PHOTO_UPLOADS.id) {
            const isIncludeType = cgcUploadTypes.CGC_PHOTO_UPLOADS.allowedTypes.includes(file[0].type)
            if (!isIncludeType) {
                sweetStatusAlert(namespace.FAILED, `Please use the formats .jpeg, .jpg or .png`, "error")
                return true
            }
        }
        return false
    }

    const handleSelectedFiles = (e, type_id) => {
        const { name, files } = e.target
        if (typeCheckForPhotoFileUpload(files, type_id)) {
            return
        }
        if (sizeCheckForFileUpload(files)) {
            return
        }
        if (nameCheckForFileUpload(files, name)) {
            return
        }
        setSelectedFiles({ ...selectedFiles, [name]: [...selectedFiles[name], files] })
    }

    useEffect(() => {
        // Perform your callback logic here
        handleUploadFiles(selectedFiles)
    }, [selectedFiles]);

    const Item = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        textAlign: "center",
        color: theme.palette.text.secondary,
        lineHeight: "40px",
        padding: theme.spacing(2), // Add padding
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(3),
    }));


    const truncateFileName = (fileName) => {
        const maxLength = 25;
        if (fileName?.length > maxLength) {
            return "..." + fileName.substring(fileName.length - maxLength);
        }
        return fileName;
    };


    const concatText = (selectedFileType) => {
        let concatText = ''
        selectedFiles[selectedFileType].forEach((file, index) => {
            if (index !== 0) {
                concatText = concatText + ', ' + file[0].name
            } else {
                concatText = concatText + file[0].name
            }
        })
        return concatText
    }

const uploadComponent = (label, selectedFileType, type_id) => {
    return (
        <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
            <div className="row align-items-center">
                <div className="col-3">
                    <Typography variant="body1" sx={{ textAlign: "left" }}>
                        {label}:
                    </Typography>
                </div>
                <div className="col-9">
                    <div>
                        <div className="">
                            <div className="file-upload-section">
                                <label
                                    htmlFor="fileInput"
                                    className="custom-file-label"
                                >
                                    {selectedFiles[selectedFileType]?.length
                                        ? `${truncateFileName(selectedFiles[selectedFileType][0][0]?.name)}${!!(selectedFiles[selectedFileType].length - 1) ? ' + ' + (selectedFiles[selectedFileType].length - 1) : ''}`
                                        : "Select a file"
                                    }
                                </label>
                                <input
                                    title={concatText(selectedFileType)}
                                    type="file"
                                    name={selectedFileType}
                                    onChange={(e) => handleSelectedFiles(e, type_id)}
                                    className="custom-file-input"
                                    style={{ width: "100%" ,cursor:'pointer'}}
                                    
                                />
                            </div>
                        </div>
                        {selectedFiles[selectedFileType].length > 0 && selectedFiles[selectedFileType].map((file, index) => (
                            <Chip
                                key={index}
                                label={truncateFileName(file[0]?.name)}
                                variant="outlined"
                                onClick={(event) => { }}
                                onDelete={() => {
                                    const selectedArray = [...selectedFiles[selectedFileType]];
                                    selectedArray.splice(index, 1);
                                    const modifiedSelectedFiles = { ...selectedFiles, [selectedFileType]: selectedArray };
                                    setSelectedFiles(modifiedSelectedFiles);
                                }}
                                sx={{ marginTop: 1, marginRight: 1 }}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </Item>
    );
};





return (
    <>
      <List
        sx={{
          width: "100%",
          maxWidth: 200,
          bgcolor: "background.paper",
        }}
        subheader={
          <ListSubheader sx={{ fontWeight: "bold", textAlign: "left" }}>
            8. File submissions
          </ListSubheader>
        }
      />
      <Grid container spacing={2} sx={{ textAlign: "left" }}>
        <Grid item xs={12}>
          {uploadComponent('Photo', 'selectedFilePhoto', cgcUploadTypes.CGC_PHOTO_UPLOADS.id)}
        </Grid>
        <Grid item xs={12}>
          {uploadComponent('NIC', 'selectedFileNIC', cgcUploadTypes.CGC_NIC_UPLOADS.id)}
        </Grid>
        <Grid item xs={12}>
          
          {uploadComponent('Signature', 'selectedFileSignature', cgcUploadTypes.CGC_SIGNATURE_UPLOADS.id)}
        </Grid>
        <Grid item xs={12}>
          
          {uploadComponent('A/L', 'selectedFileAL', cgcUploadTypes.CGC_AL_UPLOADS.id)}
        </Grid>
        <Grid item xs={12}>
         
          {uploadComponent('O/L', 'selectedFileOL', cgcUploadTypes.CGC_OL_UPLOADS.id)}
        </Grid>
        <Grid item xs={12}>
         
          {uploadComponent('Work Experience', 'selectedFileWork', cgcUploadTypes.CGC_WORK_UPLOADS.id)}
        </Grid>
        <Grid item xs={12}>
         
          {uploadComponent('Other', 'selectedFileOther', cgcUploadTypes.CGC_OTHER_UPLOADS.id)}
        </Grid>
      </Grid>
    </>
  );
}


export default CGCDocSubmission
